var map = {
	"./Index": "5db9",
	"./Index.vue": "5db9",
	"./Main": "208c",
	"./Main.vue": "208c",
	"./MainCOPY": "bd80",
	"./MainCOPY.vue": "bd80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80e3";